import get from './get';

export {
  get
};


// WEBPACK FOOTER //
// ./src/services/api/settings/index.ts